import TimelineFullImage from '../../../../timeline/TimelineFullImage/TimelineFullImage';

const Image = require('../../../../../assets/img/timeline/modal/1996-partnership.jpg');


const PartnershipContent = () => {
    return (
        <>
            <TimelineFullImage image={Image} />
            <h4>
                Corporate partnership: Avon
            </h4>
            <p>
                Our corporate partnership with Avon Australia and New Zealand has raised $11.5 million for our research program since 1996.
            </p>
        </>
    );
}

export default PartnershipContent;